import { useEffect, useState } from "react";
import Header from "../components/Header";
import { Request } from "../helpers/https";
import { SimpleToastError, SimpleToastSuccess } from "../helpers/validation/error-handlers";
import { read, utils } from "xlsx";
import { getLocalStorage } from "../helpers/utils";
import { useParams } from "react-router-dom";
// import {fileTypeFromFile} from 'file-type';

const ExcelCampaign = () => {
    const { campaignId } = useParams();
    const [loading, setLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState();
    const [sheetData, setSheetData] = useState([]);
    const [mediaCampaigns, setMediaCampaigns] = useState([]);
    const [campaign, setCampaign] = useState([]);



    //=> {ext: 'png', mime: 'image/png'}


    const formatString = (str) => {
        return str.substring(0, 8) + '...' + str.substring(str.length - 6)
    }

    const displayExcelSheet = async (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        const excelTable = document.getElementById('excelTable');

        reader.onload = () => {
            const fileData = reader.result;
            const workbook = read(fileData, { type: 'binary' });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const sheetData = utils.sheet_to_json(sheet, { header: 1 });

            for (let i = 0; i < sheetData.length; i++) {
                if (typeof sheetData[i][1] !== 'string') {
                    sheetData.splice(i)
                }
            }

            // display the sheet data in a table
            let tableHtml = '';
            for (let row of sheetData) {
                tableHtml += '<tr>';
                for (let cell of row) {
                    tableHtml += '<td>' + cell + '</td>';
                }
                tableHtml += '</tr>';
            }
            excelTable.innerHTML = tableHtml;
            setSheetData(sheetData);
        };

        reader.readAsBinaryString(file);
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        let formData = new FormData();
        // console.log({ sheetData }); return;
        formData.append('sheetData', JSON.stringify(sheetData));
        formData.append('File', selectedFile);
        formData.append('mediaCampaignId', campaign.id);

        let token = getLocalStorage('mw:user:session:id');
        let config = {
            headers: {
                "Authorization": "Bearer " + token,
            }
        }
        let url = `${process.env.REACT_APP_SERVER_URL}createExcelCampaign/`;
        let result = await Request.put(url, formData, config)
        // console.log({ result: result.data })
        if (result.ok) {
            SimpleToastSuccess(result.data.data.data)
            setInterval(() => {
                window.location.reload();
            }, 2000);
        } else {
            SimpleToastError(result.data.response.data.data)
        }
        setLoading(false)

    }

    const validateFileExtension = (fileName) => {
        try {
            let justFileName = fileName.split('.')
            let fileExtension = justFileName[1]
            if (fileExtension !== 'xlsx')
                throw new Error("Invalid file format!")

            return { ok: true }
        } catch (err) {
            SimpleToastError(err.message)
            return { ok: false }
        }
    }

    const changeHandler = (event) => {
        let res = validateFileExtension(event.target.files[0].name);
        if (res?.ok) {
            setSelectedFile(event.target.files[0]);
            displayExcelSheet(event)
        }
    };


    async function fetchMediaCampaigns() {
        let url = `${process.env.REACT_APP_SERVER_URL}excelCampaign/leaderboard/${campaignId}`;
        let result = await Request.get(url)
        // console.log({ 'xxx': result.data.data.data })
        if (result.ok) {
            setMediaCampaigns(result.data.data.data)
        }
    }
    async function fetchCampaign() {
        let url = `${process.env.REACT_APP_SERVER_URL}excelCampaign/view/${campaignId}`;
        let result = await Request.get(url)
        // console.log({ 'xxx': result.data.data.data })
        if (result.ok) {
            setCampaign(result.data.data.data[0])
        }
    }




    useEffect(async () => {
        await fetchMediaCampaigns()
        await fetchCampaign()
    }, []);



    return (

        <div className="App">
            <Header title={'Excel Campaign'} />
            <div className="row ml-auto mr-auto justify-content-center mb-lg-5">
                <div className="col-md-9">
                    <table id="excelTable" className="table table-striped table-hover"></table>
                </div>
            </div>
            <div className="row ml-auto mr-auto">
                <form className='m-auto' onSubmit={handleSubmit}>
                    <div className="form-group d-flex mb-4">
                        <div className="col-md-2">
                            <label >Select Excel Sheet:</label>
                        </div>
                        <div className="col-md-6">
                            {/* <input type="text" className="form-control" required="true" name="txnHash" placeholder="Enter transaction hash..." /> */}
                            <input type="file" name="file" onChange={changeHandler} />

                        </div>
                    </div>



                    {
                        (loading) ?
                            <button type="submit" className="btn btn-primary ms-5">
                                <div className="spinner-border-sm" role="status">
                                    <span className="sr-only"></span>
                                </div> Processing...
                            </button>

                            :
                            <>

                                <button type="submit" className="btn btn-primary">Upload data for {campaign?.title} media campaign</button>
                            </>
                    }


                </form>
            </div>

            <div className="container mt-5">
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">wallet address</th>
                            <th scope="col">no of articles</th>
                            <th scope="col">no of videos</th>
                            <th scope="col">no of social posts</th>
                            <th scope="col">points</th>
                        </tr>
                    </thead>
                    <tbody>
                        {mediaCampaigns?.map((e, index) => (
                            <tr key={index}>
                                <th scope="row">{index + 1}</th>
                                <td>{formatString(e.wallet_address)}</td>
                                <td>{e.no_of_articles}</td>
                                <td>{e.no_of_videos}</td>
                                <td>{e.no_of_social_posts}</td>
                                <td>{e.points}</td>
                                {/* <td>{e.amount_in_usd}</td> */}
                            </tr>
                        ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ExcelCampaign;